import { render, staticRenderFns } from "./b-refound-detai.vue?vue&type=template&id=32380ed0&scoped=true&"
import script from "./b-refound-detai.vue?vue&type=script&lang=js&"
export * from "./b-refound-detai.vue?vue&type=script&lang=js&"
import style0 from "./b-refound-detai.vue?vue&type=style&index=0&id=32380ed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32380ed0",
  null
  
)

export default component.exports